import axios, { AxiosResponse } from 'axios';
import { CreateVirtualFishGroupInput } from '../../types/create-virtual-fish-group-input.type';

// PUT
// Update virtual fish goup.
// /ewosapi/v1/planandprognosis/site/{localSiteId}/fishgroup/{fishGroupId}
export const putVirtualFishGroup = async (
  localSiteId: string,
  fishGroupId: string,
  request: CreateVirtualFishGroupInput
): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v1/planandprognosis/site/${localSiteId}/fishgroup/${fishGroupId}`, request);
};
